// extracted by mini-css-extract-plugin
export default {"component_slots":"Button__component_slots--slots-_rGoQ"};